export function formatNumber(number: number | bigint) {
    let formatted
    formatted = new Intl.NumberFormat().format(number)
    if (Number.isNaN(formatted)) {
        return '0'
    }
    return formatted
}
